import Tooltip, { TooltipProps } from 'antd/lib/tooltip';
import * as React from 'react';
import { runwayColors } from '../styles/globalStyles';
import { InfoCircleOutlined } from '@ant-design/icons';

const TooltipInfoIcon: React.FC<{
    tooltipContent: React.ReactNode | string;
    style?: React.CSSProperties;
    onClick?: React.MouseEventHandler<HTMLSpanElement>;
    tooltipProps?: Omit<TooltipProps, 'title'>;
    // Content specific to this user or org (their own config, identifiers) stands out from generic help copy.
    hasCustomContent?: boolean;
}> = ({ tooltipContent, style, onClick, tooltipProps, hasCustomContent }) => {
    const color = hasCustomContent ? runwayColors.primary : runwayColors.darkTextGrey;
    return (
        <Tooltip {...tooltipProps} title={tooltipContent}>
            <InfoCircleOutlined style={{ color, ...style }} onClick={onClick} />
        </Tooltip>
    );
};

export default TooltipInfoIcon;
